"use client";

import React from "react";
import { Card, CardContent } from "@/components/ui/card";
const legalData = [{
  id: "company",
  label: "Unternehmensname",
  value: "Industrial Hub Coworking GmbH"
}, {
  id: "legal-form",
  label: "Rechtsform",
  value: "Gesellschaft mit beschränkter Haftung"
}, {
  id: "headquarters",
  label: "Sitz der Gesellschaft",
  value: "Berlin, Deutschland"
}, {
  id: "register",
  label: "Handelsregister",
  value: "Amtsgericht Charlottenburg, HRB 987654 B"
}, {
  id: "ceo",
  label: "Geschäftsführer",
  value: "Lukas Schmidt, Sarah Weber"
}, {
  id: "vat",
  label: "Umsatzsteuer-ID",
  value: "DE 987 654 321"
}, {
  id: "tax",
  label: "Steuernummer",
  value: "11/222/33333"
}, {
  id: "chamber",
  label: "Zuständige Kammer",
  value: "IHK Berlin"
}];
export default function LegalInformation() {
  return;
}